import { useForm } from "react-hook-form";
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { useState } from "react";
import { getReport } from "src/apis/tickets";
import { controlBulb } from "src/apis/control";

import { DialogContent, DialogTitle, Grid, Switch, FormGroup, FormControlLabel } from '@mui/material';
import "./PlantControl.css";
export default function PlantControl({ visbile, onClose, setFee }) {
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const [value, setValue] = useState("")
    const onSubmit = data => console.log(data);
    const fetchReport = async () => {
        
        try {
           await getReport()
       } catch (error) {
          console.error(error);
        }
      };

      const controlLED = async (data) => {
        
        try {
           await controlBulb(data)
           onClose();
       } catch (error) {
          console.error(error);
        }
      };

    return (
        <Dialog open={visbile} onClose={onClose} >
            <div className="PlantFormContainer" >
                <DialogTitle>  Send Controls to Plant </DialogTitle>
                <DialogContent>
                    <form >
                        <Grid
                            spacing={2}
                            container
                            direction="row"
                            justify="center"
                            alignItems="center">
                            <Grid item md={6} xs={12} lg={6} sm={12} xl={6} className="fieldsContainer">
                                <div className="fieldswrapper">
                                    <FormGroup>
                                        <FormControlLabel control={<Switch defaultChecked />} label="Turn on/off" name="on" {...register('on')} />
                                        <FormControlLabel control={<Switch  />} label="LED1 on/off" name="LED1" {...register('LED1')} />
                                    </FormGroup>
                                    Set Fan Speed  :
                                    <input type="number" fullWidth  name="fanSpeed" {...register('fanSpeed')} />
                                    Set Temperature  : <input type="number" fullWidth name="temperature" {...register("temperature", { required: false })} />
                                    Set Humidity  : <input type="number" fullWidth name="humidity"  {...register("humidity", { required: false })} />
                                </div>
                            </Grid>
                            <Grid item md={6} xs={12} lg={6} sm={12} xl={6} className="fieldsContainer">
                                <div className="fieldswrapper">
                                <FormGroup>
                                        <FormControlLabel control={<Switch defaultChecked />} label="Pause A.I" name="ai" {...register('ai')} />
                                        <FormControlLabel control={<Switch />} label="Energy Saving" name="energy" {...register('energy')}/>
                                        <FormControlLabel control={<Switch  />} label="LED2 on/off" name="LED2" {...register('LED2')} />
                                    </FormGroup>
                                <br/>
                                    <label for="appt">Schedule Start Time</label>     <input type="time" name="startTime" {...register('startTime')}/>
                                    <label for="appt">Schedule End Time</label>       <input type="time" name="endTime" {...register('endTime')}/>

                                </div>
                            </Grid>
                            <Grid item xs={6} md={12} >
                                <div className='plantaddButton'>
                                    <Button type ="submit" variant="text" 
                                        onClick={handleSubmit(controlLED)}> Send Control </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
            </div>
        </Dialog>

    );
}